import { TooltipPosition } from '@slickdeals/blueprint-twig/javascript/components/tooltip';
import { addTagToElement, InjectType } from './cashbackTagInjector';
import { dataRole as CashbackTagDataRole } from '../patterns/cashbackTag';
/** The name of the module */
export const name = 'DealDetailCashbackTagInjector';
/**
 * Adds Cashback Tag to Deal Details page
 *
 * @param offer Loyalty offer to show
 */
export const injectCashbackTag = (offer, availableTypes) => {
    addTagToElement({
        offer,
        elm: document.querySelector('.detailLeftColumn .dealDetailsPriceInfo'),
        injectType: InjectType.Append,
        tooltipModifiers: {
            position: TooltipPosition.BottomLeft,
        },
        availableTypes,
    });
    addTagToElement({
        offer,
        elm: document.querySelector('.deal-actions .dealDetailsPriceInfo'),
        injectType: InjectType.Prepend,
        tooltipModifiers: {
            position: TooltipPosition.BottomLeft,
        },
        availableTypes,
    });
    // Adds cashback tag to thumbnail carousel on mw
    addTagToElement({
        offer,
        elm: document.querySelector('.carouselWrapper[data-role="hero-carousel-wrapper"]'),
        injectType: InjectType.InsertBefore,
        tooltipModifiers: {
            position: TooltipPosition.BottomLeft,
        },
        availableTypes,
    });
    const tagElms = document.querySelectorAll(`[data-role=${CashbackTagDataRole}]`);
    tagElms.forEach(tagElm => {
        const { style } = tagElm;
        style.removeProperty('display');
    });
};
